export default "__VITE_ASSET__BnOIJPf9__"